module.exports = __webpack_public_path__ + "129c52fed671277125a2b8354fd0e41f.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_bar_1week_show_labels.png
// module id = 865
// module chunks = 7